import 'css-chunksrc/client/scenes/workloads/wbs/task/allocationsList/details/group/completion/styles.scss';export default {
  "progressBar": "_progressBar_1uwtw_1",
  "textProgressIndicator": "_textProgressIndicator_1uwtw_10"
};